import { Notification } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalValidationErrors } from '@hero/components/molecules';

import { REVIEW_IMPORT_STEP, UPLOAD_SPREADSHEET_STEP } from './constants';
import { ReviewImport } from './ReviewImport';
import * as S from './style';
import { UploadSpreadSheet } from './UploadSpreadSheet';

const ComponentByStep = {
  [UPLOAD_SPREADSHEET_STEP]: UploadSpreadSheet,
  [REVIEW_IMPORT_STEP]: ReviewImport
};

export function SpreadSheet({
  step,
  setStep,
  setFooterProps,
  setActiveScene,
  onRequestClose,
  ...props
}) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [uploadedRecipients, setUploadedRecipients] = useState([]);
  const [tags, setTags] = useState([]);

  const pageLayoutContentRef = useRef(null);

  const Component = ComponentByStep[step];

  return (
    <>
      {tags.filter(tag => tag?.automations?.length).length > 0 && (
        <Notification
          style={{ marginBottom: 16 }}
          status="info"
          title={t('blueBadgeAutomation')}
          message={t('blueBadgeAutomationDesc')}
        />
      )}
      <ModalValidationErrors
        pageLayoutContentRef={pageLayoutContentRef}
        style={{ marginBottom: 16 }}
      />
      <S.FormContent>
        <Component
          setIsLoading={setIsLoading}
          uploadedRecipients={uploadedRecipients}
          setUploadedRecipients={setUploadedRecipients}
          setActiveScene={setActiveScene}
          isLoading={isLoading}
          setStep={setStep}
          setFooterProps={setFooterProps}
          tags={tags}
          setTags={setTags}
          onRequestClose={onRequestClose}
          {...props}
        />
      </S.FormContent>
    </>
  );
}

SpreadSheet.propTypes = {
  step: PropTypes.string,
  setStep: PropTypes.func,
  setFooterProps: PropTypes.func,
  setActiveScene: PropTypes.func,
  onRequestClose: PropTypes.func
};
